import React from "react";
import Button from "@material-ui/core/Button";
import { Link } from "react-router-dom";

function HeroContent(props) {
  return (
    <div className="hero-section">
      <h1>{props.title}</h1>
      <p>{props.para}</p>
      {props.btn !== "" && (
        <Button
          className="btn"
          variant="contained"
          color="primary"
          href="/donate"
        >
          <Link to={"/donate"}>DONATE NOW</Link>
        </Button>
      )}
    </div>
  );
}

export default HeroContent;
